import React from 'react';
import { Link } from 'react-router-dom';
import { FiShield, FiTwitter, FiFacebook, FiLinkedin, FiMail } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-primary-dark text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <FiShield size={24} className="text-primary-light" />
              <span className="text-xl font-bold">RECALL MORINGA</span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              The leading independent source for moringa supplement safety reporting, recall tracking, and consumer education. Dedicated to public health and transparency.
            </p>
            <div className="flex gap-4 pt-2">
              <a href="#" className="text-gray-400 hover:text-white transition-colors"><FiTwitter size={20} /></a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors"><FiFacebook size={20} /></a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors"><FiLinkedin size={20} /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 border-b border-gray-700 pb-2 inline-block">Quick Links</h3>
            <ul className="space-y-2 text-gray-300">
              <li><Link to="/" className="hover:text-primary-light transition-colors">Home</Link></li>
              <li><Link to="/alerts" className="hover:text-primary-light transition-colors">Safety Alerts</Link></li>
              <li><Link to="/news" className="hover:text-primary-light transition-colors">Latest News</Link></li>
              <li><Link to="/products" className="hover:text-primary-light transition-colors">Product Database</Link></li>
              <li><Link to="/resources" className="hover:text-primary-light transition-colors">Resources</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-bold mb-4 border-b border-gray-700 pb-2 inline-block">Official Sources</h3>
            <ul className="space-y-2 text-gray-300">
              <li><a href="https://www.fda.gov" target="_blank" rel="noopener noreferrer" className="hover:text-primary-light transition-colors">FDA Safety Recalls</a></li>
              <li><a href="https://www.cdc.gov" target="_blank" rel="noopener noreferrer" className="hover:text-primary-light transition-colors">CDC Outbreaks</a></li>
              <li><a href="#" className="hover:text-primary-light transition-colors">Report Adverse Event</a></li>
              <li><a href="#" className="hover:text-primary-light transition-colors">Consumer Reports</a></li>
            </ul>
          </div>

          {/* Contact / Newsletter */}
          <div>
            <h3 className="text-lg font-bold mb-4 border-b border-gray-700 pb-2 inline-block">Stay Updated</h3>
            <p className="text-gray-300 text-sm mb-4">Get critical safety alerts delivered to your inbox.</p>
            <form className="flex flex-col gap-2">
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="bg-gray-800 border border-gray-700 text-white px-4 py-2 rounded focus:outline-none focus:border-primary-light"
              />
              <button className="bg-primary-light hover:bg-blue-600 text-white px-4 py-2 rounded font-medium transition-colors">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Recall Moringa. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms of Service</Link>
            <Link to="/disclaimer" className="hover:text-white">Disclaimer</Link>
          </div>
        </div>
        <div className="mt-8 text-xs text-gray-500 text-center max-w-3xl mx-auto">
          <strong>Disclaimer:</strong> This website is for informational purposes only and does not constitute medical or legal advice. Always consult with a healthcare professional regarding supplement use. Information is aggregated from official sources but may not be exhaustive.
        </div>
      </div>
    </footer>
  );
};

export default Footer;